<template>
    <v-dialog v-model="showDialog"
              class="habit-change-date-dialog"
              min-width="300"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title>
                Подтвердите изменения
            </v-card-title>

            <v-card-text>
                <div>
                    Вы действительно хотите изменить дату начала привычки?
                </div>
                <div>
                    Все отметки до <b>{{ date.toFormat("dd.MM.yyyy") }}</b> будут удалены.
                </div>               
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            date: {
                required: true,
                type: Object
            }
        },

        emits: ["hide", "save"],

        data() {
            return {
                showDialog: true
            };
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            save() {
                this.$emit("save");
            }
        }
    };
</script>